import React, { useContext } from "react";
import { PRODUCT_TYPE_VOUCHER_MANAGER } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import VoucherSearch from "@components/VoucherManager/VoucherSearch";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const VoucherManagerSearchPage = () => {
    const { productTypeId } = useContext(ApplicationContext);

    return (
        <VersionedLayout>
            <VoucherSearch type={productTypeId === PRODUCT_TYPE_VOUCHER_MANAGER ? "voucherManager" : "seasonalVoucher"} />
        </VersionedLayout>
    );
};

export default VoucherManagerSearchPage;
